<template>
  <generic-view
    :title="$t('pictures')"
    icon="image"
    :searchable="false"
    :configurable="false"
    :show_plus="false"
  >
    <!-- <div class="ui basic segment"> -->
    <file-pond
      name="file"
      ref="pond"
      :label-idle="$t('click or drop files here')"
      v-bind:allow-multiple="true"
      v-bind:allow-revert="false"
      v-bind:server="{
        url: api_host,
        timeout: enterprise_setup.upload_timeout,
        process: {
          url: '/product_picture/do-upload',
          method: 'POST',
          headers: {
            'x-access-token': token_session,
          },
          withCredentials: false,
          ondata: function (formData) {
            formData.append('u', product.uuid);
            return formData;
          },
        },
      }"
      v-on:error="filepond_error"
      v-on:processfile="filepond_process"
    />
    <div class="ui four cards">
      <div class="card" v-for="(img, idx) in files" :key="idx">
        <div class="image">
          <img
            v-img:name
            class="ui image"
            :src="resource_url(img.setup.filename)"
          />
        </div>
        <!-- <div class="content">
          <a class="header">Matt Giampietro</a>
          <div class="meta">
            <a>Friends</a>
          </div>
          <div class="description">Matthew is an interior designer living in New York.</div>
        </div>-->
        <!-- <div class="extra content">
          <span class="right floated">Joined in 2013</span>
          <a>
            <i class="user icon"></i>
            75 Friends
          </a>
        </div>-->
        <div class="ui bottom attached basic buttons">
          <div
            :data-tooltip="$t('download')"
            class="ui button"
            @click.stop="download(img)"
          >
            <i class="ui download icon"></i>
          </div>
          <div
            :data-tooltip="$t('delete')"
            class="ui button"
            @click.stop="remove(img, idx)"
          >
            <i class="ui red trash icon"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
    <!-- <div class="ui small images" style="display: block">
      <img v-img:name class="ui image" :src="img.src" v-for="(img, idx) in images" :key="idx" />
    </div>-->

    <template v-for="(mdl, index) in picture_modals">
      <component
        :is="mdl"
        :key="index"
        :product="$props.product"
        v-on:succedded="succedded"
        v-on:destroy="destroy"
      ></component>
    </template>
  </generic-view>
</template>

<script>
import { local_api, enterprise_setup, error_toast, api_host } from "@/utils";
// import _ from "lodash";
import GenericView from "@/components/GenericContainer";
// import { v4 } from "uuid";
// Import FilePond
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";

import moment from "moment";

const FilePond = vueFilePond();

export default {
  filters: {
    fromNow(value) {
      return moment(value).fromNow();
    },
  },
  props: {
    module: Object,
    product: Object,
  },
  components: {
    "generic-view": GenericView,
    FilePond,
  },
  computed: {
    token_session() {
      let token = this.$session.get("token");
      return token;
    },
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  data() {
    return {
      picture_modals: [],
      files: [],
      api_host: api_host,
    };
  },
  methods: {
    remove(img, index) {
      let vm = this;
      this.$alertify.confirm(
        this.$t("are you sure to remove picture?"),
        function () {
          local_api(vm, "post", "/product_picture/do-remove", {
            u: img.uuid,
          })
            .then(() => {
              vm.files.splice(index, 1);
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
    destroy() {
      this.picture_modals = [];
      // this.selected_address = {};
    },
    succedded(address) {
      let trgtIdx = this.addresses.findIndex((n) => n.uuid == address.uuid);
      if (trgtIdx != -1) this.addresses.splice(trgtIdx, 1, address);
      else this.addresses.push(address);
    },
    download(image) {
      console.log(image);
    },
    // filter(query) {
    //   if (query == "") this.addresses = this.all_addresses;
    //   else
    //     this.addresses = this.all_addresses.filter(
    //       (p) =>
    //         p.setup &&
    //         (p.setup.address.toUpperCase().includes(query.toUpperCase()) ||
    //           p.setup.description.toUpperCase().includes(query.toUpperCase()) ||
    //           p.setup.type.toUpperCase().includes(query.toUpperCase())),
    //     );
    // },
    filepond_error(a, b) {
      console.log("error", a, b);
    },
    filepond_process(event, inst) {
      // let x1 = this.$refs.pond;
      // console.log(x1, inst);
      if (inst.serverId) {
        let r = JSON.parse(inst.serverId);
        if (!r.success) console.log(r.error);
        else this.files.push(r.data);
      }
      // x1.removeFiles().then(r => {
      //   console.log(r);
      // });
    },
    resource_url(file_name) {
      return `${api_host}/public/uploads/product_picture/${file_name}`;
    },
  },
  mounted() {
    let vm = this;
    // this.processing = true;

    setTimeout(function () {
      local_api(vm, "post", "/product_picture/do-get-initial-items", {
        uuid: vm.$props.product.uuid,
      })
        .then((items) => {
          vm.files = items;
          // vm.all_pictures = _.clone(items);
          // vm.processing = false;
        })
        .catch((err) => {
          error_toast(err);
          console.error(err);
        });
    }, 100);
  },
  watch: {},
};
</script>

<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
</style>
